import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/styles/index.css'; // Importando nossos estilos Tailwind
// --- NOVA IMPORTAÇÃO ---
// Importa o registrador do Service Worker.
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- NOVA LINHA DE CÓDIGO ---
// Ativa o Service Worker. Isso é essencial para que as notificações push funcionem.
// Ao chamar .register(), o seu aplicativo passará a funcionar offline e
// terá o Service Worker ativo para receber notificações.
serviceWorkerRegistration.register();
